// package: trendhim.service.info
// file: protos/info/info.proto

var protos_info_info_pb = require("../../protos/info/info_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Info = (function () {
  function Info() {}
  Info.serviceName = "trendhim.service.info.Info";
  return Info;
}());

Info.GetItem = {
  methodName: "GetItem",
  service: Info,
  requestStream: false,
  responseStream: false,
  requestType: protos_info_info_pb.GetItemRequest,
  responseType: protos_info_info_pb.Item
};

Info.ListItems = {
  methodName: "ListItems",
  service: Info,
  requestStream: false,
  responseStream: false,
  requestType: protos_info_info_pb.ListItemsRequest,
  responseType: protos_info_info_pb.ListItemsResponse
};

Info.SearchItems = {
  methodName: "SearchItems",
  service: Info,
  requestStream: false,
  responseStream: false,
  requestType: protos_info_info_pb.SearchItemsRequest,
  responseType: protos_info_info_pb.SearchItemsResponse
};

Info.GetSection = {
  methodName: "GetSection",
  service: Info,
  requestStream: false,
  responseStream: false,
  requestType: protos_info_info_pb.GetSectionRequest,
  responseType: protos_info_info_pb.Section
};

Info.ListSections = {
  methodName: "ListSections",
  service: Info,
  requestStream: false,
  responseStream: false,
  requestType: protos_info_info_pb.ListSectionsRequest,
  responseType: protos_info_info_pb.ListSectionsResponse
};

exports.Info = Info;

function InfoClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InfoClient.prototype.getItem = function getItem(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Info.GetItem, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

InfoClient.prototype.listItems = function listItems(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Info.ListItems, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

InfoClient.prototype.searchItems = function searchItems(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Info.SearchItems, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

InfoClient.prototype.getSection = function getSection(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Info.GetSection, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

InfoClient.prototype.listSections = function listSections(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Info.ListSections, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

exports.InfoClient = InfoClient;

